<template>
  <div class="search-content">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'ApplyLayout',
    data () {
      return {
        tabs: {
          items: [
            {
              key: '1',
              title: '报名管理'
            },
           {
             key: '2',
             title: '人员成绩管理'
           },
            {
              key: '3',
              title: '送培报名'
            },
          ],
          active: () => {
            switch (this.$route.path) {
              case '/huiyi/ApplyList':
                return '1'
              case '/huiyi/MemberList':
                return '2'
              case '/songpei/ApplyList':
                return '3'
              default:
                return '1'
            }
          },
          callback: (key) => {
            switch (key) {
              case '1':
                this.$router.push('/huiyi/ApplyList')
                break
              case '2':
                this.$router.push('/huiyi/MemberList')
                break
              case '3':
                this.$router.push('/songpei/ApplyList')
                break
              default:
                this.$router.push('/workplace')
            }
          }
        },
        search: false
      }
    },
    computed: {

    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .search-head{
    background-color: #fff;
    margin: -25px -24px -24px;
    .search-input{
      text-align: center;
      margin-bottom: 16px;
    }
  }
  .search-content{
    margin-top: 0px;
  }
</style>
